<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <b-row class="justify-content-between">
      <b-col md="4" class="mb-2">
        <input
          type="date"
          class="form-control"
          v-model="leadDate"
          @change="getByDate"
        />
      </b-col>

      <b-col md="4">
          <div class="d-flex">
            <input type="text" v-model="leadSeach" class="form-control" />
            <b-button variant="outline-success" class="border-0" @click="fetchLeads">
              <i class="bx bx-search font-size-24"></i>
            </b-button>
          </div>
      </b-col>
    </b-row>
    <div class="drag-container">
      <div class="row drag-list d-flex">
        <div
          class="col-lg-3 drag-column kanban-card"
          v-for="(lead, lIndex) in leads"
          :key="lIndex"
        >
          <div class="card h-100">
            <div class="card-body">
              <span class="drag-column-header">
                <span class="d-flex justify-content-between">
                  <h4 class="card-title mb-4 pb-1">
                    {{ lead.status.name_ru }}
                  </h4>
                  <span v-if="lIndex === 0">
                    <b-button
                      variant="outline-success"
                      size="sm"
                      @click="addClientToLead"
                    >
                      <i class="bx bx-plus"></i>
                    </b-button>
                  </span>
                </span>

                <form class="d-flex mb-3">
                  <input type="text" v-model="lead.search" />
                  <b-button variant="outline-primary border-0" @click.prevent="onSearch(lead.status.id, lIndex)">
                    <i class="bx bx-search font-size-20"></i>
                  </b-button>
                </form>
              </span>
              <draggable
                class="list-group h-100"
                :id="`lead-${lead.status.id}`"
                group="tasks"
                :list="lead.clients.data"
                @start="drag = true"
                @end="drag = false"
                @add="leadAdded"
              >
                <div
                  v-for="(l, index) in lead.clients.data"
                  :key="index"
                  class="card task-box"
                >
                  <div class="card-body">
                    <div
                      class="d-flex justify-content-between"
                      @click="
                        $router.push({
                          name: 'DailyOrdersDetail',
                          params: { id: l.id },
                        })
                      "
                    >
                      <span>
                        {{ l.client.full_name }}
                      </span>
                      <span
                        class="badge rounded-pill font-size-12"
                        :class="{
                          'badge-soft-success ': l.client.is_physical,
                          'badge-soft-primary ': !l.client.is_physical,
                        }"
                      >
                        {{ l.client.is_physical ? "Физ." : "Юр." }}
                      </span>
                    </div>
                    <hr />
                    <div
                      class="w-100"
                      v-for="(number, index) in l.client.numbers"
                      :key="index"
                    >
                      <span class="font-size-13">
                        <i class="bx bx-phone-call"></i>
                        {{ number.mobile }}</span
                      >
                    </div>
                    <hr />
                    <div>
                      <h5 class="font-size-15"></h5>
                    </div>

                    <div class="avatar-group float-start">
                      <div class="avatar-group-item">
                        <a href="javascript: void(0);" class="d-inline-block w-100">
                          <!--                        <img-->
                          <!--                            :src="`${lead.author.full_name}`"-->
                          <!--                            class="rounded-circle avatar-xs"-->
                          <!--                            alt-->
                          <!--                        />-->
                          <i class="bx bx-user"></i>
                          {{ l.author.full_name }}
                        </a>
                      </div>
                    </div>
                    <div class="w-100 d-flex justify-content-between mt-3">
                      <p class="text-muted mb-1">
                        <i class="bx bx-calendar"></i> {{ l.date }}
                      </p>
                      <p class="mb-1">
                        <i class="bx bx-plus font-size-18 text-warning me-1" @click="addLeadOrder(l.id,lIndex)"></i>
                        <i class="bx bx-basket"></i>{{l.ordersCount}}
                      </p>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="AddModalActive" hide-footer size="lg">
      <ClientsSearch @pushNewLead="pushNewLead" />
    </b-modal>
    <b-modal v-model="orderFormAction" hide-footer size="lg">
      <OrderForm :lead_id="orderParams.lead_id" @appendOrder="appendOrder" />
    </b-modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";

import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import ClientsSearch from "./includes/ClientsSearch";
import OrderForm from "./includes/OrderForm";

import { upcomingTasks, progressTasks, completedTasks } from "./data-kanban";
// import {mapActions} from 'vuex';

export default {
  name: "daily-orders",
  page: {
    title: "Kanban Board",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    draggable,
    PageHeader,
    ClientsSearch,
    OrderForm,
  },
  data() {
    return {
      upcomingTasks: upcomingTasks,
      progressTasks: progressTasks,
      completedTasks: completedTasks,
      title: "Kanban Board",
      leadSeach: "",
      items: [
        {
          text: "Tasks",
          href: "/",
        },
        {
          text: "Kanban Board",
          active: true,
        },
      ],
      leadStatus: {
        added: null,
        removed: null,
      },
      AddModalActive: false,
      leads: [],
      searchTitle: "",
      tend: [],
      orderFormAction: false,
      orderParams: {
        lead_id: null,
        lead_index: null,
      },
    };
  },
  computed: {
    leadDate: {
      get() {
        return this.$store.state.kanban.leadDate;
      },
      set(val) {
        this.$store.commit("kanban/SET_LEAD_DATE", val);
        this.fetchLeads();
      },
    },
  },
  mounted() {
    this.checkRoleAcl("SuperAdmin");
  },

  created() {
    this.fetchLeads();
  },
  methods: {
    addClientToLead() {
      this.AddModalActive = true;
    },
    fetchLeads() {
      this.$store.dispatch("kanban/fetchKanbanData", {search: this.leadSeach}).then(() => {
        this.leads = this.$store.state.kanban.kanban.map((item) =>
          Object.assign({}, item, {search: ""})
        );
      });
    },
    getChangeDraggable(event) {
      if (event.added) {
        this.leadStatus.added = event.added;
      } else if (event.removed) {
        this.leadStatus.removed = event.removed;
      }

      if (this.leadStatus.added && this.leadStatus.removed) {
        let a = {
          from_status: this.leadStatus.removed.element.status_id,
          to_status: this.leadStatus.added.element.status_id,
          from_index: this.leadStatus.removed.oldIndex,
          to_index: this.leadStatus.added.newIndex,
        };
        this.$store.dispatch("kanban/changeLeadStatus", a);
      }
    },
    leadAdded(event) {
      let fromLead = event.from.id;
      let toLead = event.to.id;

      this.$store
        .dispatch("kanban/changeLeadStatus", {
          from_status: fromLead.split("-")[1],
          to_status: toLead.split("-")[1],
          from_index: event.oldIndex,
          to_index: event.newIndex,
        })
        .then(() => {
          // eslint-disable-next-line no-console
          console.log(this.leads);
        });
    },
    getByDate() {
      this.fetchLeads();
    },
    pushNewLead(lead) {
      this.leads[0].clients.data.push(lead);
      this.AddModalActive = false;
      this.$router.push({name: "DailyOrdersDetail", params:{id:lead.id}});
    },
    onSearch(status_id, lead_index) {
      this.$store.dispatch('kanban/searchByStatus',
          {params: {status_id, search: this.leads[lead_index].search},lead_index}).then(res => {
            this.leads[lead_index].clients = res.data;
      });
    },
    appendOrder() {
      const itemIndex = this.leads[this.orderParams.lead_index].clients.data.findIndex(item => item.id === this.orderParams.lead_id);
      this.leads[this.orderParams.lead_index].clients.data[itemIndex].ordersCount += 1;
      this.orderFormAction = false;
      this.$vs.notification({
        icon: "<i class='bx bx-select-multiple' ></i>",
        color: "success",
        position: "top-right",
        title: this.$t('message.Success'),
        text: this.$t('message.OrderAdded'),
      })
    },
    addLeadOrder(lead_id, lead_index) {
      this.orderParams = {
        lead_id,
        lead_index,
      }
      this.orderFormAction = true;
    }
  },
};
</script>

<style scoped lang="scss">
.kanban-card > .card {
  background-color: transparent;
  min-height: calc(100% + 100vh);
}
.kanban-card {
  .list-group {
    min-height: calc(100% + 1000px);
    box-sizing: border-box;
  }
}
</style>
